import React from 'react';
import PropTypes from 'prop-types';
var generateRandomAnimationDelay = function generateRandomAnimationDelay() {
  var rand = Math.round(Math.random() * 100) / 100;
  return "".concat(rand, "s");
};
var Circle = function Circle(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.isIE && /*#__PURE__*/React.createElement("div", {
    className: "svg ".concat(props.className)
  }), !props.isIE && /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: props.className,
    viewBox: "0 0 886 835",
    style: {
      animationDelay: generateRandomAnimationDelay()
    },
    preserveAspectRatio: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: "381.52",
    cy: "382.987",
    rx: "380.8",
    ry: "380.719"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "381.556",
    cy: "383.527",
    rx: "380.8",
    ry: "380.719",
    transform: "translate(46.821 72.017)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "382.637",
    cy: "382.915",
    rx: "380.8",
    ry: "380.719",
    transform: "translate(122.455 21.605)"
  }))));
};
Circle.propTypes = {
  className: PropTypes.string,
  isIE: PropTypes.bool
};
Circle.defaultProps = {
  className: '',
  isIE: true
};
export default Circle;